export type GuideFeatureIcon = 'target' | 'message' | 'layout' | 'timer' | 'sliders' | 'eye';

export const guideFeatures: { label: string; text: string; icon: GuideFeatureIcon; bg: string; fg: string }[] = [
  {
    label: 'Goals & equipment',
    text: 'A clear goal for the lesson and the exact equipment to bring out.',
    icon: 'target',
    bg: '#E85C18',
    fg: '#071C33',
  },
  {
    label: 'Instructions',
    text: 'Concrete, ready-to-say cues so you know what to tell the class.',
    icon: 'message',
    bg: '#3DD6EE',
    fg: '#071C33',
  },
  {
    label: 'Diagrams',
    text: 'Court and station diagrams that show where players, cones and targets go.',
    icon: 'layout',
    bg: '#0EA5E9',
    fg: '#071C33',
  },
  {
    label: 'Timings',
    text: 'Every activity is timed to fit a 40-minute lesson from warm-up to close.',
    icon: 'timer',
    bg: '#F97316',
    fg: '#071C33',
  },
  {
    label: 'Easier / harder',
    text: 'Simple options to adjust each activity for a mixed-level group.',
    icon: 'sliders',
    bg: '#0B2A49',
    fg: '#3DD6EE',
  },
  {
    label: 'Observation',
    text: 'What to watch for, so you can see who is ready to move on.',
    icon: 'eye',
    bg: '#EF4444',
    fg: '#071C33',
  },
];

export const teachingSteps = [
  {
    title: 'Open the plan',
    text: 'Start with Lesson 1. Read the goal, equipment list and timings before class.',
  },
  {
    title: 'Set up the space',
    text: 'Follow the diagram to place cones, targets and groups before pupils arrive.',
  },
  {
    title: 'Teach and adapt',
    text: 'Use the instructions, switch to easier or harder options, and note what you observe.',
  },
];
